import { render, staticRenderFns } from "./BookSearch.vue?vue&type=template&id=5ff31a8e&scoped=true&"
import script from "./BookSearch.vue?vue&type=script&lang=js&"
export * from "./BookSearch.vue?vue&type=script&lang=js&"
import style0 from "./BookSearch.vue?vue&type=style&index=0&id=5ff31a8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff31a8e",
  null
  
)

export default component.exports